module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-form', {
    attrs: {
      "label-width": "200px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_vm._l((_vm.form), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 10
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "收货人"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "55%"
      },
      attrs: {
        "placeholder": "姓名"
      },
      model: {
        value: (item.username),
        callback: function($$v) {
          _vm.$set(item, "username", $$v)
        },
        expression: "item.username"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "手机号码"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "55%"
      },
      attrs: {
        "placeholder": "11位手机号"
      },
      model: {
        value: (item.telephone),
        callback: function($$v) {
          _vm.$set(item, "telephone", $$v)
        },
        expression: "item.telephone"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "地区信息"
      }
    }, [_c('el-cascader', {
      attrs: {
        "options": _vm.regions
      },
      on: {
        "visible-change": function($event) {
          return _vm.changeClick(index)
        },
        "change": _vm.handleRegionChange
      },
      model: {
        value: (item.regions_id),
        callback: function($$v) {
          _vm.$set(item, "regions_id", $$v)
        },
        expression: "item.regions_id"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "详细地址"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "详细地址"
      },
      model: {
        value: (item.adrdetail),
        callback: function($$v) {
          _vm.$set(item, "adrdetail", $$v)
        },
        expression: "item.adrdetail"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "邮政编码"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "邮政编码"
      },
      model: {
        value: (item.postalCode),
        callback: function($$v) {
          _vm.$set(item, "postalCode", $$v)
        },
        expression: "item.postalCode"
      }
    })], 1), _vm._v(" "), (index === 1) ? _c('el-form-item', [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.delAddress(index)
        }
      }
    }, [_vm._v("删除")])], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.isShow) ? _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    on: {
      "click": _vm.addAddress
    }
  })])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAddress
    }
  }, [_vm._v("确认保存")])], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2bafb1aa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bafb1aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/address/setting.vue
// module id = 2572
// module chunks = 0